import styled from "styled-components";

export const Img = styled.img<{
  $borderRadius?: string;
}>`
  border-radius: ${({ $borderRadius }) => $borderRadius ?? "50%"};
  border: 1px solid ${({ theme: { colors } }) => colors['grey-300']};;
`